import { NEXT_PUBLIC_BIGCOMMERCE_CHANNEL_CURRENCY } from '@utils/client-side-config'

import { formatPrice } from '@commerce/product/use-price'
import { ProductVariant } from '../_components/designUpload/types'

const getProductOptionUnitCost = ({
  productOption,
  locale,
}: {
  productOption: ProductVariant
  locale: string
}): string | null => {
  if (!productOption) {
    return null
  }

  const currencyCode =
    productOption?.currencyCode || NEXT_PUBLIC_BIGCOMMERCE_CHANNEL_CURRENCY
  const price = Number(productOption?.price)

  const stringQuantity = String(productOption?.quantity)?.toLowerCase() || ''
  const formattedQuantity = stringQuantity.includes('sample')
    ? stringQuantity.split('sample')?.[0]?.trim()
    : stringQuantity
  const quantity = Number(formattedQuantity)

  if (!quantity || !price || !currencyCode) {
    return null
  }

  const unitCostString = formatPrice({
    amount: Number(productOption?.price) / quantity,
    currencyCode: currencyCode,
    locale: locale,
  })

  if (!unitCostString) {
    return null
  }

  return unitCostString
}

export { getProductOptionUnitCost }
